'use client';

import { useEffect } from 'react';

/**
 * Automatický reload pri ChunkLoadError.
 *
 * Po deployi novej verzie Next.js vygeneruje nové súbory v /next/static/chunks/
 * s iným hashom. Používateľ s otvorenou session má v cache starý HTML/runtime,
 * ktorý sa snaží načítať už neexistujúci chunk → ChunkLoadError.
 *
 * Tento handler pri zachytení ChunkLoadError stránku automaticky obnoví,
 * čím sa natiahnu nové chunky a appka znova funguje (bez potreby Ctrl+F5).
 */
export function ChunkLoadErrorHandler() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const message = event?.message ?? '';
      if (
        typeof message === 'string' &&
        (message.includes('ChunkLoadError') || message.includes('Loading chunk') || message.includes('Loading CSS chunk'))
      ) {
        window.location.reload();
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const message =
        typeof event?.reason?.message === 'string'
          ? event.reason.message
          : String(event?.reason ?? '');
      if (
        message.includes('ChunkLoadError') ||
        message.includes('Loading chunk') ||
        message.includes('Loading CSS chunk')
      ) {
        event.preventDefault();
        window.location.reload();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
